import * as React from "react";
import { graphql } from "gatsby";
import Navbar from "./elements/navbar";
import Footer from "./elements/footer";
import FakeChat from "./elements/fake-chat-btn";
// import Cookies from "./elements/cookies";
// import ScrollToTop from "./elements/scroll-top";
import { useTranslation } from "gatsby-plugin-react-i18next";
import type { HeadFC, PageProps } from "gatsby";
import FloatScollBtn from "./elements/float-scoll-btn";
import Cookies from './elements/cookies'


type LayoutProps = {
    id?: string;
    children: JSX.Element | JSX.Element[];
};

const Layout: React.FC<LayoutProps> = (props: LayoutProps) => {
    return (
        <main id={props.id}>
            <Navbar />
            <div className="page-content">{props.children}</div>
            <Footer />
            <FloatScollBtn />
            <FakeChat />
            <Cookies/>
            {/* // <ScrollToTop />
        // <Cookies /> */}
        </main>
    );
};

export default Layout;

// export const query = graphql`
//     query ($language: String!) {
//         locales: allLocale(filter: { language: { eq: $language } }) {
//             edges {
//                 node {
//                     ns
//                     data
//                     language
//                 }
//             }
//         }
//     }
// `;
